export default {
  data() {
    return {
      paginationOptions: [
        {
          label: '10',
          value: 10
        },
        {
          label: '15',
          value: 15
        },
        {
          label: '25',
          value: 25
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        },
        {
          label: '200',
          value: 200
        },
        {
          label: '500',
          value: 500
        }
      ],
    }
  },
  methods: {
    prepareSelectedOptionsNames(objects, nameField){
      let formattedNames = null;
      let names = objects.map(item => item[nameField]);

      formattedNames = names.slice(0, 2).join(', ');

      if (names.length > 2)
      {
        formattedNames += ' + ' + (names.length - 2) + ' more';
      }

      return formattedNames;
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/mixins/baseTableMixin.js